import type { FC } from 'react';
import type { IProductData } from '../../types/affiliates.types';

export interface IProductLogo {
  src: string;
  alt: string;
}

export interface IProductCardProps {
  data: IProductData;
  logos: IProductLogo[];
  products: IProductData[];
  onActivateButtonClick?: () => void;
  onReactivateButtonClick?: () => void;
  onGetHint?: () => void;
  onGetAccountRecovery?: () => void;
}

export interface IProductCard {
  key: string;
  cps: string;
  logos: IProductLogo[];
  primary: IProductData;
  products: IProductData[];
  bindingId: string;
  Component: FC<IProductCardProps>;
}

export type CpHandler = (products: IProductData[]) => IProductCard[];

export const byOrderUI = (a: IProductData, b: IProductData) => (a.orderUI ?? Infinity) - (b.orderUI ?? Infinity);

export const toLogos = (products: IProductData[]): IProductLogo[] =>
  [...products]
    .sort(byOrderUI)
    // El alt va por producto: cpDescription es del CP y se repite entre los suyos.
    .map(product => ({ src: product.metadata?.image, alt: product.name || product.metadata?.name || product.cps }))
    .filter(logo => Boolean(logo.src));
